import { requestChainOfferStep } from "../chain_offer_screen/chain_offer_purchase_service.js";
import type { ChainOfferStepResult } from "../chain_offer_screen/chain_offer_purchase_service.js";

export const CHAIN_VIDEO_PLACEMENT = 'chain_video';

export function requestChainVideoStep( offer_id: string, step_id: string, type: 'paid' | 'free' | 'rewarded' ): Promise<ChainOfferStepResult>
{
  return requestChainOfferStep( offer_id, step_id, type, { placement: CHAIN_VIDEO_PLACEMENT } );
}
